import { MARKET_SYMBOLS, type PriceBook } from '../../core/types.ts';
import { pct, price } from '../lib/format.ts';
import { useFlash } from '../lib/useSnapshot.ts';
import { Skeleton } from './ui.tsx';

function Quote({ book, symbol }: { book: PriceBook; symbol: (typeof MARKET_SYMBOLS)[number] }) {
  const q = book[symbol];
  const flash = useFlash(q.price);
  const wide = q.dispersion > 0.005;

  return (
    <div className="flex items-baseline gap-2.5 px-4 py-2.5">
      <span className="text-[13px] font-semibold text-muted">{symbol}</span>
      <span className={`num text-[15px] font-semibold ${flash}`}>{price(q.price)}</span>
      <span
        className={`num text-[10px] ${wide ? 'text-down' : 'text-dim'}`}
        title={`${q.sources.map((s) => `${s.source} ${price(s.price)}`).join(' · ')}\nmedian of ${q.sources.length} sources, spread ${pct(q.dispersion, 3)}`}
      >
        {q.sources.length} src · ±{pct(q.dispersion, 2)}
      </span>
    </div>
  );
}

export function PriceStrip({ prices }: { prices: PriceBook | null }) {
  if (!prices) return <Skeleton className="h-[46px]" />;

  return (
    <div className="panel flex flex-wrap items-center divide-edge sm:divide-x">
      {MARKET_SYMBOLS.map((s) => (
        <Quote key={s} book={prices} symbol={s} />
      ))}
      <p className="ml-auto px-4 py-2.5 text-[11px] text-dim">
        Median of Binance, Coinbase, Kraken and CoinGecko. A single bad feed cannot move the book.
      </p>
    </div>
  );
}
